import React from "react";
import { connect } from "react-redux";
import SalaryAdjustmentTable from "./components/SalaryAdjustmentTable";
import UploadButton from "components/button/upload";
import DownloadButton from "components/button/download";

const SalaryAdjustments = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<SalaryAdjustmentTable/>
	      	
	      	<div className="btn-container">
	      		<DownloadButton downloadPath="salary-adjustments" title="Download" filters={filters}/>
	      		<UploadButton uploadPath='salary-adjustments' title="Upload"/>
	      	</div>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.salaryAdjustment.salaryAdjustmentList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdjustments);